import { Component, computed, inject } from '@angular/core'
import { NgOptimizedImage } from '@angular/common'
import { RouterLink } from '@angular/router'
import { Dialog } from '@angular/cdk/dialog'

import { ActiveRoute } from '@core/navigation'
import { ROLES } from '@core/data/models'
import { AppStore } from '@core/store'
import { Icon } from '@shared/ui'
import { UploadTicketModal } from '@features/tickets'

@Component({
  selector: 'bottom-nav',
  imports: [RouterLink, NgOptimizedImage, Icon],
  templateUrl: './nav.html'
})
export class Nav {
  readonly #dialog = inject(Dialog)
  readonly #store = inject(AppStore)

  protected readonly activeRoute = inject(ActiveRoute)

  /**
   * El menú del ejecutivo es otro: no sube tickets ni redime, así que pierde el
   * botón central y cambia premios por el muro.
   */
  protected readonly executive = computed(() => this.#store.currentUser()?.role === ROLES.EXECUTIVE)

  /**
   * La pestaña junto al perfil también cambia con el rol: el ejecutivo registra
   * líderes y el gerente revisa su historial. Comparten icono.
   */
  protected readonly fourth = computed(() => (this.executive() ? { link: '/register', label: 'Registro' } : { link: '/tickets', label: 'Historial' }))

  protected openTicketModal(): void {
    this.#dialog.open(UploadTicketModal, { panelClass: 'modal-frame' })
  }
}
